// src/pages/Home.js
import React from 'react';
import PoliticaPrivacidad from '../PoliticaYTerminosComponents/PoliticaPrivacidad';
function Home() {
  return (
    <div>
      <PoliticaPrivacidad/>
    </div>
  );
}

export default Home;